module.exports = __webpack_public_path__ + "static/media/RU.da3ad937.svg";